import isEmpty from 'lodash.isempty';
import { emojiToUnicode } from './stringUtilities';

export function executeCarefully(func, ...args) {
    if (func !== undefined && typeof func === 'function') {
        func(...args);
    }
}

export function collectionHelper(elements) {
    return {
        firstOrDefault: function (condition) {
            if (!isEmpty(elements)) {
                if (condition === undefined) {
                    return elements[0];
                }

                var foundItems = elements.filter(condition);
                if (!isEmpty(foundItems)) {
                    return foundItems[0];
                }
            }
        },
        getWhere: function (condition) {
            var filteredItems = !isEmpty(elements) ? elements.filter(condition) : [];
            return filteredItems;
        },
        updateWhere: function (condition) {
            return {
                set: function (setter) {
                    if (!isEmpty(elements)) {
                        for (var i = 0; i < elements.length; i++) {
                            var current = elements[i];
                            if (condition(current)) {
                                setter(elements[i]);
                            }
                        }
                    }
                    return elements;
                }
            };
        },
        indexOf: function (condition) {
            if (!isEmpty(elements)) {
                var filteredItems = elements.filter(condition);
                if (!isEmpty(filteredItems)) {
                    return elements.indexOf(filteredItems[0]);
                }
            }
            return -1;
        },
        join: function (separator, selector) {
            if (!isEmpty(elements)) {
                const values = [];
                for (var i = 0; i < elements.length; i++) {
                    const value = selector(elements[i]);
                    values.push(value);
                }

                if (values.length > 0) {
                    return values.join(separator);
                }
            }
        }
    };
};

export function getVideoElementPlaying(videoElement) {
    return videoElement.currentTime > 0 
        && !videoElement.paused 
        && !videoElement.ended 
        && videoElement.readyState > videoElement.HAVE_CURRENT_DATA;
}

export function base64Encode(value) {
    return window.btoa(encodeURIComponent(value));
}

export function base64Decode(value) {
    return decodeURIComponent(window.atob(value));
}

export async function emojiToBase64(emojis) {
    try {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        let results = [];

        for (const { emoji, fontSize = 42 } of emojis) {
            const padding = Math.ceil(fontSize * 0.12);
            const canvasSize = fontSize + padding * 2;
            canvas.width = canvasSize;
            canvas.height = canvasSize;

            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';

            ctx.font = `${fontSize}px "Segoe UI Emoji", "Apple Color Emoji", "Noto Color Emoji", "Twemoji Mozilla", sans-serif`;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillStyle = '#000000';

            ctx.clearRect(0, 0, canvas.width, canvas.height);

            const centerX = canvas.width / 2;
            const centerY = canvas.height / 2;

            ctx.fillText(emoji, centerX, centerY + Math.ceil(fontSize * 0.10));

            const base64URL = canvas.toDataURL('image/png', 1.0);
            ctx.closePath();

            results.push({
                fontSize: fontSize,
                base64Image: base64URL.split(',')[1],
                unicodeEmoji: emojiToUnicode(emoji),
            });
        }

        canvas.remove();

        // Filters the `results` array to keep only unique items based on the combination of `unicodeEmoji` and `fontSize` properties.
        // If there are multiple objects with the same `unicodeEmoji` and `fontSize`, only the first one is kept.
        const uniqueResults = results.filter((item, index, self) => index === self.findIndex((t) => t.unicodeEmoji === item.unicodeEmoji && t.fontSize === item.fontSize));

        return uniqueResults;
    } catch (error) {
        console.error(`Error converting emojis to base64:`, error);
        return [];
    }
}